module.exports = __webpack_public_path__ + "static/media/03@2x.0dc68c51.png";